import React from "react";
import { CoachingNote, Severity } from "../../types";
import styles from "./CoachingNoteCard.module.css";

interface CoachingNoteCardProps {
  note: CoachingNote;
  actionLabel?: string;
  onAction?: () => void;
}

function SeverityIcon({ severity }: { severity: Severity }) {
  if (severity === "issue") {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="4" y1="22" x2="4" y2="3" />
        <path d="M4 3h14l-3 5 3 5H4" />
      </svg>
    );
  }
  if (severity === "warning") {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2l10 10-10 10L2 12z" />
      </svg>
    );
  }
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

export default function CoachingNoteCard({ note, actionLabel, onAction }: CoachingNoteCardProps) {
  return (
    <article className={`${styles.card} ${styles[`sev_${note.severity}`]}`}>
      <div className={styles.headerRow}>
        <span className={styles.iconWrap}>
          <SeverityIcon severity={note.severity} />
        </span>
        <h3 className={styles.title}>{note.title}</h3>
      </div>
      <p className={styles.body}>{note.body}</p>
      {actionLabel && (
        <button className={styles.actionLink} onClick={onAction}>
          {actionLabel} →
        </button>
      )}
    </article>
  );
}
